/**
 * Canonical EventBus channel names. Typed so renames are compiler-checked at emit/subscribe sites.
 */
export const TrackingBusEvent = {
  ConsentGranted: 'consent:granted',
  ConsentWithdrawn: 'consent:withdrawn',
  TabActive: 'tab:active',
  TabInactive: 'tab:inactive',
  TabActivity: 'tab:activity',
  TabReset: 'tab:reset', // tab session reset -> generate new tab_id
  CustomerResolved: 'customer:resolved',
  PurchaseCompleted: 'purchase:completed',
  PageUnload: 'page:unload',
  PageBfcache: 'page:bfcache',
} as const;

export type TrackingBusEventName = (typeof TrackingBusEvent)[keyof typeof TrackingBusEvent];
